export const Check = ({ strokeColor = '#050505' }: { strokeColor?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path
      d="M2 8.05556L6.44444 12.5L14.4444 4.5"
      stroke={strokeColor}
      strokeWidth="2.05714"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
